/** Snaps a coordinate to the nearest grid line. Used by the scene and ladder editors. */
export function snapToGrid(value: number, gridSize: number): number {
  if (gridSize <= 0) return value;
  const snapped = Math.round(value / gridSize) * gridSize;
  // Normalise -0 to 0 so serialized documents stay clean.
  return snapped === 0 ? 0 : snapped;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
